import { useMemo } from 'react';

export function useFilteredByExpiry<T>(
  items: Array<T>,
  isExpired: (item: T) => boolean,
  hideExpired: boolean,
): Array<T> {
  return useMemo(
    () => (hideExpired ? items.filter((item) => !isExpired(item)) : items),
    [items, isExpired, hideExpired],
  );
}
